export default __webpack_public_path__ + "static/media/2082.9b338871.png";